import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faEnvelope, faLock, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FaEye, FaEyeSlash, FaLock, FaCheckCircle } from "react-icons/fa";
import { useNavigate, useLocation ,useParams} from "react-router-dom";
import { BASE_URL } from "../Apis/endpoints";
import axios from "axios";

const Setpassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({ password: "", confirmPassword: "" });
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isTokenValid, setIsTokenValid] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const { token } = useParams();


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
        setError("Passwords do not match");
        return;
      }

    try {
        const response = await axios.post(`${BASE_URL}api/userauth/reset-password/${token}/`, {
            new_password: formData.password,
        });

        if (response.status === 200) {
            // setMessage({ text: "Password has been reset successfully.", type: "success" });
            setIsSuccess(true);
            setTimeout(() => navigate("/login"), 3000);
        }
    } catch (err) {
        setError(err.response?.data?.error || "Failed to reset password. Please try again.");
      } finally {
        setIsLoading(false);
    }
};

  return (
    <div className="flex flex-col items-center justify-center min-h-screen "
    style={{
        flexDirection: "column",
        backgroundImage: "url('/images/Login-background.svg')",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
    }}
    >
      <div className="bg-white shadow-md rounded-lg p-6 w-full max-w-md">
        {isSuccess ? (
          <div className="text-center">
            <FaCheckCircle className="text-green-500 text-5xl mx-auto mb-4" />
            <h2 className="text-lg font-semibold">Password Reset Successful!</h2>
            <p className="text-gray-600">Redirecting to login...</p>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-center mb-4">Reset Your Password</h2>
            {error && <div className="text-red-500 text-sm text-center mb-3">{error}</div>}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Password</label>
                <div className="relative">
                  <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    className="w-full p-2 pl-10 border rounded-lg focus:ring focus:ring-blue-300"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    onChange={handleChange}
                    placeholder="*****************"
                  />
                  <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ?  <FaEye />:<FaEyeSlash />}
                  </span>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Confirm Password</label>
                <div className="relative">
                  <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    className="w-full p-2 pl-10 border rounded-lg focus:ring focus:ring-blue-300"
                    name="confirmPassword"
                    type={showPassword ? "text" : "password"}
                    onChange={handleChange}
                    placeholder="*****************"
                  />
                  <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                  </span>
                </div>
              </div>
              <button
                className="w-full bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600 transition disabled:opacity-50 flex justify-center items-center gap-2"
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Update Password"}
                <FaLock />
              </button>
            </form>
                                    <div className="mt-4 text-center">
                                        <a href="/login" className="text-[#2C67F2] font-semibold hover:underline flex items-center justify-center">
                                            <FontAwesomeIcon icon={faChevronLeft} className="text-lg mr-1" />
                                            Back to login screen
                                        </a>
                                    </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Setpassword;